import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';

const brochureSlice = createSlice({
    name: 'brochureDownloadUrl',
    initialState: {
        url: "",
        fetchStatus: LoadingStatus.Idle,
        error: null,
    },
    reducers: {
        fetchBrochureDownloadUrl: (state) => {
            state.url = null;
            state.fetchStatus = LoadingStatus.Loading;
        },
        fetchBrochureDownloadUrlSuccess: (state, action) => {
            state.url = action.payload;
            state.fetchStatus = LoadingStatus.Succeeded;
        },
        fetchBrochureDownloadUrlFailure: (state, action) => {
            state.fetchStatus = LoadingStatus.Failed;
            state.error = action.payload;
        }
    },
});

export default brochureSlice;